null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/milessabin/shapeless/shapeless-2.3.3/core/src/main/scala/shapeless/singletons.scala